import React from "react";
import { Sun, Moon, MonitorCog } from "lucide-react";
import { useTheme } from "@/contexts/ThemeContext";

/**
 * Compact three-way theme toggle (Light / Auto / Dark). Shares state with the
 * landing page toggle via ThemeContext + localStorage.
 */
export const ThemeToggle: React.FC<{ compact?: boolean }> = ({ compact = false }) => {
  const { mode, setMode } = useTheme();
  const opts: Array<{ v: "light" | "dark" | "auto"; icon: any; label: string }> = [
    { v: "light", icon: Sun, label: "Light" },
    { v: "auto", icon: MonitorCog, label: "Auto" },
    { v: "dark", icon: Moon, label: "Dark" },
  ];
  const sz = compact ? "h-6 w-6" : "h-7 w-7";
  const icon = compact ? "h-3 w-3" : "h-3.5 w-3.5";
  return (
    <div
      data-testid="theme-toggle"
      role="radiogroup"
      aria-label="Theme"
      className="inline-flex items-center gap-0.5 p-0.5 rounded-full border border-[color:var(--sg-border)] bg-[color:var(--sg-card)]"
    >
      {opts.map(({ v, icon: Icon, label }) => (
        <button
          key={v}
          data-testid={`theme-toggle-${v}`}
          aria-checked={mode === v}
          role="radio"
          title={label}
          onClick={() => setMode(v)}
          className={`${sz} rounded-full flex items-center justify-center transition-colors ${
            mode === v
              ? "bg-[color:var(--sg-fg)] text-[color:var(--sg-card)]"
              : "text-[color:var(--sg-muted)] hover:text-[color:var(--sg-fg)]"
          }`}
        >
          <Icon className={icon} strokeWidth={2} />
        </button>
      ))}
    </div>
  );
};
